import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cup-shadow",
  "use": "icon-cup-shadow-usage",
  "viewBox": "0 0 22 20",
  "content": "<symbol viewBox=\"0 0 22 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-cup-shadow\">\n<path d=\"M5.49966 0H7.99966H21.9998V20H3.99976L4.99966 19C8.59958 17 6.49963 13.8333 4.99966 12.5C-1.00034 10.1 0.832994 3.16667 2.49966 0H5.49966Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcon/svg/cup-shadow.svg
// module id = P9vj
// module chunks = 258